import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-phone-input',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './phone-input.html',
  styleUrl: './phone-input.scss',
})
export class PhoneInput {
  @Input() label = 'Phone Number';
  @Input() labelClass = '';
  @Input() inputClass = '';
  @Input() countryCodeClass = '';
  @Input() placeholder = 'Input Customer Phone Number';
  @Input() countryCodes: string[] = ['+234'];
  @Input() control!: FormControl;
  private readonly phoneRegex = /^\d{11}$/;

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.control.addValidators([Validators.pattern(this.phoneRegex)]);
  }
}
